<template>
    <div>
        <fullscreen-loading v-if="loading"/>

        <div class="row mt-3">
            <div class="col-12">
                <div class="card">
                    <div class="card-header pb-3">
                        <div class="d-flex justify-content-between align-items-center">
                            <span class="h4">{{ $t('emaillogs.title') }}</span>
                        </div>
                    </div>
                    <div class="card-body">
                        <table class="table table-sm table-no-side-paddings table-striped">
                            <thead>
                            <tr>
                                <ordering @change="load()" v-model="order" field="to" tag="th">
                                    {{ $t('emaillogs.to') }}
                                </ordering>
                                <ordering @change="load()" v-model="order" field="subject" tag="th">
                                    {{ $t('emaillogs.subject') }}
                                </ordering>
                                <ordering @change="load()" v-model="order" field="sparkpost_transaction_id" tag="th">
                                    {{ $t('emaillogs.external_id') }}
                                </ordering>
                                <ordering @change="load()" v-model="order" field="sparkpost_transaction_id" tag="th">
                                    {{ $t('emaillogs.sent_date') }}
                                </ordering>
                                <ordering @change="load()" v-model="order" field="sparkpost_state" class="text-right" tag="th">
                                    {{ $t('emaillogs.status') }}
                                </ordering>
                            </tr>
                            </thead>

                            <tbody>
                            <tr>
                                <td><input @change="load(1)" class="form-control form-control-filtering" type="text" v-model="filtering.to"/></td>
                                <td><input @change="load(1)" class="form-control form-control-filtering" type="text" v-model="filtering.subject"/></td>
                                <td><input @change="load(1)" class="form-control form-control-filtering" type="text" v-model="filtering.sparkpost_transaction_id"/></td>
                                <td></td>
                                <td>
                                    <select @change="load(1)" class="form-control form-control-filtering" v-model="filtering.sparkpost_state">
                                        <option :value="null">{{ $t('emaillogs.choose_option') }}</option>
                                        <option :value="1">{{ $t('emaillogs.status_sent') }}</option>
                                        <option :value="3">{{ $t('emaillogs.status_delivered') }}</option>
                                        <option :value="4">{{ $t('emaillogs.status_bounce') }}</option>
                                        <option :value="5">{{ $t('emaillogs.status_out_of_bound') }}</option>
                                        <option :value="6">{{ $t('emaillogs.status_delay') }}</option>
                                    </select>
                                </td>
                            </tr>
                            <tr v-for="emailLog of emailLogs.data">
                                <td>{{ emailLog.to.join(', ') }}</td>
                                <td>{{ emailLog.subject }}</td>
                                <td>{{ emailLog.sparkpost_transaction_id }}</td>
                                <td>{{ emailLog.created_at | moment('DD-MM-YYYY H:mm') }}</td>
                                <td class="text-right">
                                    <span class="badge badge-info" v-if="emailLog.sparkpost_state === 1">{{ $t('emaillogs.status_sent') }}</span>
                                    <span class="badge badge-success" v-else-if="emailLog.sparkpost_state === 3">{{ $t('emaillogs.status_delivered') }}</span>
                                    <span class="badge badge-danger" v-else-if="emailLog.sparkpost_state === 4">{{ $t('emaillogs.status_bounce') }}</span>
                                    <span class="badge badge-danger" v-else-if="emailLog.sparkpost_state === 5">{{ $t('emaillogs.status_out_of_bound') }}</span>
                                    <span class="badge badge-warning" v-else-if="emailLog.sparkpost_state === 6">{{ $t('emaillogs.status_delay') }}</span>
                                </td>
                            </tr>

                            <tr v-if="emailLogs.data.length === 0 && !loading">
                                <td colspan="4" class="no-results">{{ $t('emaillogs.no_results') }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="card-footer border-0">
                        <Pagination :pagination="emailLogs" @change="load"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Pagination from "../../components/Pagination";
    import FullscreenLoading from "../../components/FullscreenLoading";
    import Ordering from "../../components/Ordering";
    import filteringFromObject from "../../utils/filteringFromObject";

    export default {

        components: {
            Pagination,
            FullscreenLoading,
            Ordering
        },

        data() {
            return {
                loading: false,
                emailLogs: {
                    current_page: 1,
                    data: []
                },

                order: 'created_at,desc',
                filtering: {
                    to: null,
                    subject: null,
                    sparkpost_transaction_id: null,
                    sparkpost_state: null,
                }
            }
        },

        created(){
            this.load(1);
        },

        methods: {
            async load(page = undefined) {
                if (page) {
                    this.emailLogs.current_page = page;
                }

                this.loading = true;

                try {
                    const response = await this.$http.get('/api/email-logs', {
                        params: {
                            page: this.emailLogs.current_page,
                            order: this.order,
                            filters: filteringFromObject(this.filtering)
                        }
                    });

                    this.emailLogs = response.data;
                } catch (exception) {
                    if(!exception.response || (exception.response && exception.response.status !== 401)) {
                        alert('Failed to load email logs');
                    }
                }

                this.loading = false;
            }
        }
    }

</script>
